export var Type;
(function (Type) {
    Type["UNKNOWN"] = "UNKNOWN";
    Type["UPVOTE"] = "UPVOTE";
    Type["DOWNVOTE"] = "DOWNVOTE";
})(Type || (Type = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["ANONYMOUS"] = "ANONYMOUS";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["USER"] = "USER";
    IdentityType["SERVICE"] = "SERVICE";
    /** indicates everyone who is a member of a group */
    IdentityType["MEMBER_GROUP"] = "MEMBER_GROUP";
})(IdentityType || (IdentityType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
//# sourceMappingURL=types.impl.js.map